//types.js

export const SHOW_GENERAL_ERROR = 'SHOW_GENERAL_ERROR';
export const HIDE_GENERAL_ERROR = 'HIDE_GENERAL_ERROR';
export const CLOSE_DROP_DOWN_ON_SCHEDULE_SUCCESS = 'CLOSE_DROP_DOWN_ON_SCHEDULE_SUCCESS';
export const REQUEST_CLOSE_DROPDOWN_ON_SCHEDULE = 'REQUEST_CLOSE_DROPDOWN_ON_SCHEDULE';
export const REDIRECT_URL = 'REDIRECT_URL';
export const REDIRECT_URL_SUCCEEDED = 'REDIRECT_URL_SUCCEEDED';
export const OPEN_MODAL = 'OPEN_MODAL';
export const OPEN_MODAL_SUCCEEDED = 'OPEN_MODAL_SUCCEEDED';
export const HANDLE_SCHEDULE_TICKET_CLICK = 'HANDLE_SCHEDULE_TICKET_CLICK';
export const HANDLE_SCHEDULE_TICKET_CLICK_SUCCEEDED = 'HANDLE_SCHEDULE_TICKET_CLICK_SUCCEEDED';
export const REMOVE_SCHEDULE_TICKET_CLICK = 'REMOVE_SCHEDULE_TICKET_CLICK';
export const REMOVE_SCHEDULE_TICKET_CLICK_SUCCEEDED = 'REMOVE_SCHEDULE_TICKET_CLICK_SUCCEEDED';

export const REFRESH_TOKEN_AUTH = 'REFRESH_TOKEN_AUTH';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_API_MESSAGES_SHOW = 'LOGIN_API_MESSAGES_SHOW';

export const REQUEST_LOGIN_GUEST = 'REQUEST_LOGIN_GUEST';
export const LOGIN_SUCCEEDED_GUEST = 'LOGIN_SUCCEEDED_GUEST';
export const LOGIN_FAILED_GUEST = 'LOGIN_FAILED_GUEST';
export const LOGIN_API_MESSAGES_SHOW_GUEST = 'LOGIN_API_MESSAGES_SHOW_GUEST';

export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const REGISTER_SUCCEEDED = 'REGISTER_SUCCEEDED';
export const REGISTER_FAILED = 'REGISTER_FAILED';
export const REGISTER_API_MESSAGES_SHOW = 'REGISTER_API_MESSAGES_SHOW';
export const SEND_TEMPORARY_PASSWORD = 'SEND_TEMPORARY_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const REQUEST_UPLOAD = 'REQUEST_UPLOAD';
export const UPLOAD_SUCCEDED = 'UPLOAD_SUCCEDED';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';

export const SEARCH_CITY = 'SEARCH_CITY';
export const SEARCH_COUNTY = 'SEARCH_COUNTY';
export const SEARCH_CITY_SUCCEEDED = 'SEARCH_CITY_SUCCEEDED';
export const SEARCH_COUNTY_SUCCEEDED = 'SEARCH_COUNTY_SUCCEEDED';

export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const SEARCH_SUCCEEDED = 'SEARCH_SUCCEEDED';
export const SEARCH_FAILED = 'SEARCH_FAILED';

export const REQUEST_MOVIES_BOX_OFFICE = 'REQUEST_MOVIES_BOX_OFFICE';
export const MOVIES_BOX_OFFICE_SUCCEEDED = 'MOVIES_BOX_OFFICE_SUCCEEDED';
export const MOVIES_BOX_OFFICE_FAILED = 'MOVIES_BOX_OFFICE_FAILED';

export const REQUEST_MOVIES_BOX_OFFICE_HOME = 'REQUEST_MOVIES_BOX_OFFICE_HOME';
export const MOVIES_BOX_OFFICE_SUCCEEDED_HOME = 'MOVIES_BOX_OFFICE_SUCCEEDED_HOME';
export const MOVIES_BOX_OFFICE_FAILED_HOME = 'MOVIES_BOX_OFFICE_FAILED_HOME';

export const REQUEST_DATES = 'REQUEST_DATES';
export const REQUEST_DATES_SUCCEEDED = 'REQUEST_DATES_SUCCEEDED';
export const REQUEST_DATES_FAILED = 'REQUEST_DATES_FAILED';

export const BOX_OFFICE_DISTRIBUTORS = 'BOX_OFFICE_DISTRIBUTORS';
export const BOX_OFFICE_DISTRIBUTORS_SUCCEEDED = 'BOX_OFFICE_DISTRIBUTORS_SUCCEEDED';

export const BOX_OFFICE_STUDIOS = 'BOX_OFFICE_STUDIOS';
export const BOX_OFFICE_STUDIOS_SUCCEEDED = 'BOX_OFFICE_STUDIOS_SUCCEEDED';

export const LOGIN_API_FACEBOOK = 'LOGIN_API_FACEBOOK';
export const LOGIN_API_GOOGLE = 'LOGIN_API_GOOGLE';

export const GET_MOVIE_SLIDES = 'GET_MOVIE_SLIDES';
export const GET_SOON_MOVIES = 'GET_SOON_MOVIES';
export const GET_SOON_MOVIES_SUCCEEDED = 'GET_SOON_MOVIES_SUCCEEDED';
export const GET_RECENT_MOVIES = 'GET_RECENT_MOVIES';
export const GET_RECENT_MOVIES_SUCCEEDED = 'GET_RECENT_MOVIES_SUCCEEDED';
export const GET_MOVIE_DETAILS = 'GET_MOVIE_DETAILS';
export const GET_MOVIE_DETAILS_SUCCEEDED = 'GET_MOVIE_DETAILS_SUCCEEDED';
export const GET_MOVIE_TIME_SCHEDULE = 'GET_MOVIE_TIME_SCHEDULE';
export const GET_MOVIE_TIME_SCHEDULE_SUCCEEDED = 'GET_MOVIE_TIME_SCHEDULE_SUCCEEDED';
export const ADD_MOVIE_TO_FAVORITE = 'ADD_MOVIE_TO_FAVORITE';
export const REMOVE_MOVIE_FROM_FAVORITE = 'REMOVE_MOVIE_FROM_FAVORITE';
export const SEND_MOVIE_REVIEW = 'SEND_MOVIE_REVIEW';
export const GET_ALL_MOVIES = 'GET_ALL_MOVIES';
export const GET_ALL_MOVIES_SUCCEEDED = 'GET_ALL_MOVIES_SUCCEEDED';
export const GET_ALL_MOVIES_SEE_MORE = 'GET_ALL_MOVIES_SEE_MORE';
export const GET_ALL_MOVIES_SEE_MORE_SUCCEEDED = 'GET_ALL_MOVIES_SEE_MORE_SUCCEEDED';
export const GET_RECENT_MOVIES_PAGE = 'GET_RECENT_MOVIES_PAGE';
export const GET_RECENT_MOVIES_PAGE_SUCCEEDED = 'GET_RECENT_MOVIES_PAGE_SUCCEEDED';
export const GET_RECENT_MOVIES_PAGE_SEE_MORE = 'GET_RECENT_MOVIES_PAGE_SEE_MORE';
export const GET_RECENT_MOVIES_PAGE_SEE_MORE_SUCCEEDED = 'GET_RECENT_MOVIES_PAGE_SEE_MORE_SUCCEEDED';
export const ADD_MOVIE_TO_FAVORITE_FROM_ALL_MOVIES = 'ADD_MOVIE_TO_FAVORITE_FROM_ALL_MOVIES';
export const ADD_MOVIE_TO_FAVORITE_FROM_RECENT_MOVIES = 'ADD_MOVIE_TO_FAVORITE_FROM_RECENT_MOVIES';
export const ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE = 'ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE';
export const ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM = 'ADD_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM';
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_ALL_MOVIES = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_ALL_MOVIES';
export const REMOVE_MOVIE_FROM_FAVORITE_FORM_RECENT_MOVIES = 'REMOVE_MOVIE_FROM_FAVORITE_FORM_RECENT_MOVIES';
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_SCHEDULE = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_SCHEDULE';
export const REMOVE_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM = 'REMOVE_MOVIE_TO_FAVORITE_FROM_SCHEDULE_CAROUSEL_ITEM';

export const GET_LAST_COMMENTS = 'GET_LAST_COMMENTS';
export const GET_LAST_COMMENTS_SUCCEEDED = 'GET_LAST_COMMENTS_SUCCEEDED';

export const GET_MOVIE_THEATERS = 'GET_MOVIE_THEATERS';
export const GET_MOVIE_THEATERS_SUCCEEDED = 'GET_MOVIE_THEATERS_SUCCEEDED';
export const GET_MOVIE_THEATERS_SEE_MORE = 'GET_MOVIE_THEATERS_SEE_MORE';
export const GET_MOVIE_THEATERS_SEE_MORE_SUCCEEDED = 'GET_MOVIE_THEATERS_SEE_MORE_SUCCEEDED';
export const ADD_CINEMA_ON_FAVORITE = 'ADD_CINEMA_ON_FAVORITE';
export const ADD_CINEMA_ON_FAVORITE_SUCCEEDED = 'ADD_CINEMA_ON_FAVORITE_SUCCEEDED';
export const REMOVE_CINEMA_ON_FAVORITE = 'REMOVE_CINEMA_ON_FAVORITE';
export const REMOVE_CINEMA_ON_FAVORITE_SUCCEEDED = 'REMOVE_CINEMA_ON_FAVORITE_SUCCEEDED';
export const GET_HALL_CONFIGURATION = 'GET_HALL_CONFIGURATION';
export const GET_HALL_CONFIGURATION_SUCCEEDED = 'GET_HALL_CONFIGURATION_SUCCEEDED';
export const STORE_SELECTED_SEATS = 'STORE_SELECTED_SEATS';
export const STORE_SELECTED_SEATS_SUCCEEDED = 'STORE_SELECTED_SEATS_SUCCEEDED';
export const STORE_SELECTED_COUCH = 'STORE_SELECTED_COUCH';
export const STORE_SELECTED_COUCH_SUCCEEDED = 'STORE_SELECTED_COUCH_SUCCEEDED';
export const CLEAR_SELECTED_SEATS_AND_COUCH = 'CLEAR_SELECTED_SEATS_AND_COUCH';
export const CLEAR_HALL_CONFIGURATION = 'CLEAR_HALL_CONFIGURATION';
export const CLEAR_HALL_CONFIGURATION_SUCCEEDED = 'CLEAR_HALL_CONFIGURATION_SUCCEEDED';
export const ADD_MOVIETHEATER_TO_FAVORITE = 'ADD_MOVIETHEATER_TO_FAVORITE';
export const REMOVE_MOVIETHEATER_FROM_FAVORITE = 'REMOVE_MOVIETHEATER_FROM_FAVORITE';
export const GET_MOVIE_THEATERS_WITH_TICKETS = 'GET_MOVIE_THEATERS_WITH_TICKETS';
export const GET_MOVIE_THEATERS_WITH_TICKETS_SUCCEEDED = 'GET_MOVIE_THEATERS_WITH_TICKETS_SUCCEEDED';
export const GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE = 'GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE';
export const GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE_SUCCEEDED = 'GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE_SUCCEEDED';
export const STORE_SELECTED_TICKETS = 'STORE_SELECTED_TICKETS';
export const STORE_SELECTED_TICKETS_SUCCEEDED = 'STORE_SELECTED_TICKETS_SUCCEEDED'; 
export const REMOVE_SELECTED_TICKETS = 'REMOVE_SELECTED_TICKETS';
export const REMOVE_SELECTED_TICKETS_SUCCEEDED = 'REMOVE_SELECTED_TICKETS_SUCCEEDED';

export const GET_ALL_NEWS = 'GET_ALL_NEWS';
export const GET_SLIDER_NEWS = 'GET_SLIDER_NEWS';
export const GET_ALL_NEWS_SUCCEEDED = 'GET_ALL_NEWS_SUCCEEDED';
export const GET_SLIDER_NEWS_SUCCEEDED = 'GET_SLIDER_NEWS_SUCCEEDED';
export const GET_LAST_NEWS = 'GET_LAST_NEWS';
export const GET_LAST_NEWS_SUCCEEDED = 'GET_LAST_NEWS_SUCCEEDED';
export const GET_LAST_NEWS_FROM_ALL_CATEGORIES = 'GET_LAST_NEWS_FROM_ALL_CATEGORIES';
export const GET_LAST_NEWS_FROM_ALL_CATEGORIES_SUCCEEDED = 'GET_LAST_NEWS_FROM_ALL_CATEGORIES_SUCCEEDED';
export const GET_NEWS_DETAILS = 'GET_NEWS_DETAILS';
export const GET_NEWS_DETAILS_SUCCEEDED = 'GET_NEWS_DETAILS_SUCCEEDED';
export const GET_FAVORITE_NEWS = 'GET_FAVORITE_NEWS';
export const GET_FAVORITE_NEWS_SUCCEEDED = 'GET_FAVORITE_NEWS_SUCCEEDED';
export const ADD_NEWS_TO_FAVORITE = 'ADD_NEWS_TO_FAVORITE';
export const ADD_NEWS_TO_FAVORITE_SUCCEEDED = 'ADD_NEWS_TO_FAVORITE_SUCCEEDED';
export const ADD_NEWS_COMMENT = 'ADD_NEWS_COMMENT';
export const ADD_NEWS_COMMENT_SUCCEEDED = 'ADD_NEWS_COMMENT_SUCCEEDED';
export const REMOVE_NEWS_FROM_FAVORITE = 'REMOVE_NEWS_FROM_FAVORITE';
export const REMOVE_NEWS_FROM_FAVORITE_SUCCEEDED = 'REMOVE_NEWS_FROM_FAVORITE_SUCCEEDED';
export const GET_NEWS_FROM_CATEGORY = 'GET_NEWS_FROM_CATEGORY';
export const GET_NEWS_FROM_CATEGORY_SUCCEEDED = 'GET_NEWS_FROM_CATEGORY_SUCCEEDED';
export const GET_NEWS_FROM_CATEGORY_SEE_MORE = 'GET_NEWS_FROM_CATEGORY_SEE_MORE';
export const GET_NEWS_FROM_CATEGORY_SEE_MORE_SUCCEEDED = 'GET_NEWS_FROM_CATEGORY_SEE_MORE_SUCCEEDED';
export const GET_RECOMMENDED_NEWS = 'GET_RECOMMENDED_NEWS';
export const GET_RECOMMENDED_NEWS_SUCCEEDED = 'GET_RECOMMENDED_NEWS_SUCCEEDED';

export const GET_ALL_TAGS = 'GET_ALL_TAGS';
export const GET_ALL_TAGS_SUCCEEDED = 'GET_ALL_TAGS_SUCCEEDED';
export const GET_CONTENT_BY_TAG = 'GET_CONTENT_BY_TAG';
export const GET_CONTENT_BY_TAG_SUCCEEDED = 'GET_CONTENT_BY_TAG_SUCCEEDED';
export const SEARCH_ENTITY_IN_SITE = 'SEARCH_ENTITY_IN_SITE';
export const SEARCH_ENTITY_IN_SITE_SUCCEEDED = 'SEARCH_ENTITY_IN_SITE_SUCCEEDED';
export const ADD_MOVIE_TO_FAVORITE_FROM_SEARCH = 'ADD_MOVIE_TO_FAVORITE_FROM_SEARCH';
export const ADD_ARTICLE_FROM_FAVORITE_FROM_SEARCH = 'ADD_ARTICLE_FROM_FAVORITE_FROM_SEARCH';
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_SEARCH = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_SEARCH';
export const REMOVE_ARTICLE_FROM_FAVORITE_FROM_SEARCH = 'REMOVE_ARTICLE_FROM_FAVORITE_FROM_SEARCH';

export const GET_GENRE_FILTERS = 'GET_GENRE_FILTERS';
export const GET_STATUS_FILTERS = 'GET_STATUS_FILTERS';
export const GET_TYPE_FILTERS = 'GET_TYPE_FILTERS';
export const GET_CINEMA_FILTERS = 'GET_CINEMA_FILTERS';
export const GET_DISTRIBUTORS = 'GET_DISTRIBUTORS';
export const GET_STUDIOS = 'GET_STUDIOS';
export const GET_GENRE_FILTERS_SUCCEEDED = 'GET_GENRE_FILTERS_SUCCEEDED';
export const GET_STATUS_FILTERS_SUCCEEDED = 'GET_STATUS_FILTERS_SUCCEEDED';
export const GET_TYPE_FILTERS_SUCCEEDED = 'GET_TYPE_FILTERS_SUCCEEDED';
export const GET_CINEMA_FILTERS_SUCCEEDED = 'GET_CINEMA_FILTERS_SUCCEEDED';
export const GET_DISTRIBUTORS_SUCCEEDED = 'GET_DISTRIBUTORS_SUCCEEDED';
export const GET_STUDIOS_SUCCEEDED = 'GET_STUDIOS_SUCCEEDED';

export const REQUEST_MOVIES_BY_CINEMA = 'REQUEST_MOVIES_BY_CINEMA';
export const REQUEST_MOVIES_BY_CINEMA_SUCCEEDED = 'REQUEST_MOVIES_BY_CINEMA_SUCCEEDED';
export const REQUEST_MOVIES_BY_CINEMA_FAILED = 'REQUEST_MOVIES_BY_CINEMA_FAILED';
export const REQUEST_SORT_TYPES_CINEMA_SCHEDULE = 'REQUEST_SORT_TYPES_CINEMA_SCHEDULE';
export const SORT_TYPES_CINEMA_SCHEDULE_SUCCEEDED = 'SORT_TYPES_CINEMA_SCHEDULE_SUCCEEDED';
export const SORT_TYPES_CINEMA_SCHEDULE_FAILED = 'SORT_TYPES_CINEMA_SCHEDULE_FAILED';
export const REQUEST_SCHEDULE_MOVIES_ALL = 'REQUEST_SCHEDULE_MOVIES_ALL';
export const SCHEDULE_MOVIES_ALL_SUCCEEDED = 'SCHEDULE_MOVIES_ALL_SUCCEEDED';
export const SCHEDULE_MOVIES_ALL_FAILED = 'SCHEDULE_MOVIES_ALL_FAILED';
export const REQUEST_MOVIES_BY_CINEMA_ID = 'REQUEST_MOVIES_BY_CINEMA_ID';
export const REQUEST_MOVIES_BY_CINEMA_ID_SUCCEEDED = 'REQUEST_MOVIES_BY_CINEMA_ID_SUCCEEDED';
export const REQUEST_MOVIES_BY_CINEMA_ID_FAILED = 'REQUEST_MOVIES_BY_CINEMA_ID_FAILED';

export const GET_SAVED_NEWS = 'GET_SAVED_NEWS';
export const GET_SAVED_NEWS_SUCCEEDED = 'GET_SAVED_NEWS_SUCCEEDED';
export const GET_SAVED_NEWS_SEE_MORE = 'GET_SAVED_NEWS_SEE_MORE';
export const GET_SAVED_NEWS_SEE_MORE_SUCCEEDED = 'GET_SAVED_NEWS_SEE_MORE_SUCCEEDED';
export const GET_FAVORITE_CINEMAS = 'GET_FAVORITE_CINEMAS';
export const GET_FAVORITE_CINEMAS_SUCCEEDED = 'GET_FAVORITE_CINEMAS_SUCCEEDED';
export const GET_FAVORITE_CINEMAS_SEE_MORE = 'GET_FAVORITE_CINEMAS_SEE_MORE';
export const GET_FAVORITE_CINEMAS_SEE_MORE_SUCCEEDED = 'GET_FAVORITE_CINEMAS_SEE_MORE_SUCCEEDED';
export const GET_YOUR_RETINGS = 'GET_YOUR_RETINGS';
export const GET_YOUR_RETINGS_SUCCEEDED = 'GET_YOUR_RETINGS_SUCCEEDED';
export const GET_FAVORITE_MOVIES = 'GET_FAVORITE_MOVIES';
export const GET_FAVORITE_MOVIES_SUCCEEDED = 'GET_FAVORITE_MOVIES_SUCCEEDED';
export const GET_FAVORITE_MOVIES_SEE_MORE = 'GET_FAVORITE_MOVIES_SEE_MORE';
export const GET_FAVORITE_MOVIES_SEE_MORE_SUCCEEDED = 'GET_FAVORITE_MOVIES_SEE_MORE_SUCCEEDED';
export const GET_UNVIEWED_NOTIFICATION_COUNT = 'GET_UNVIEWED_NOTIFICATION_COUNT';
export const GET_UNVIEWED_NOTIFICATION_COUNT_SUCCEEDED = 'GET_UNVIEWED_NOTIFICATION_COUNT_SUCCEEDED';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_DETAILS_SUCCEEDED = 'GET_USER_DETAILS_SUCCEEDED';
export const GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
export const GET_NOTIFICATION_LIST_SUCCEEDED = 'GET_NOTIFICATION_LIST_SUCCEEDED';
export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const REMOVE_PROFILE_MOVIE_FROM_FAVORITE = 'REMOVE_PROFILE_MOVIE_FROM_FAVORITE';
export const REMOVE_PROFILE_NEWS_FROM_FAVORITE = 'REMOVE_PROFILE_NEWS_FROM_FAVORITE';
export const REMOVE_CINEMA_FROM_FAVORITE = 'REMOVE_CINEMA_FROM_FAVORITE';
export const STORE_FACEBOOK_OR_GOOGLE_RESPONSE = 'STORE_FACEBOOK_OR_GOOGLE_RESPONSE';
export const STORE_FACEBOOK_OR_GOOGLE_RESPONSE_SUCCEEDED = 'STORE_FACEBOOK_OR_GOOGLE_RESPONSE_SUCCEEDED';
export const INCREMENT_PENDING_REQUESTS = 'INCREMENT_PENDING_REQUESTS';
export const DECREMENT_PENDING_REQUESTS = 'DECREMENT_PENDING_REQUESTS';
export const GET_FESTIVAL_DETAILS = 'GET_FESTIVAL_DETAILS';
export const GET_FESTIVAL_DETAILS_SUCCEEDED = 'GET_FESTIVAL_DETAILS_SUCCEEDED';
export const GET_FESTIVALS = 'GET_FESTIVALS';
export const GET_FESTIVALS_SUCCEEDED = 'GET_FESTIVALS_SUCCEEDED';
export const ADD_FESTIVAL_TO_FAVORITE = 'ADD_FESTIVAL_TO_FAVORITE';
export const REMOVE_FESTIVAL_FROM_FAVORITE = 'REMOVE_FESTIVAL_FROM_FAVORITE';
export const GET_FESTIVAL_LOCATIONS = 'GET_FESTIVAL_LOCATIONS';
export const GET_FESTIVAL_LOCATIONS_SUCCEEDED = 'GET_FESTIVAL_LOCATIONS_SUCCEEDED';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_SUCCEEDED = 'GET_EVENTS_SUCCEEDED';
export const GET_EVENT_DETAILS = 'GET_EVENT_DETAILS';
export const GET_EVENT_DETAILS_SUCCEEDED = 'GET_EVENT_DETAILS_SUCCEEDED';
export const ADD_EVENT_TO_FAVORITE = 'ADD_EVENT_TO_FAVORITE';
export const REMOVE_EVENT_FROM_FAVORITE = 'REMOVE_EVENT_FROM_FAVORITE';
export const GET_SOON_IN_CINEMA_MOVIES = 'GET_SOON_IN_CINEMA_MOVIES';
export const GET_SOON_IN_CINEMA_MOVIES_SUCCEEDED = 'GET_SOON_IN_CINEMA_MOVIES_SUCCEEDED';
export const GET_NOTIFICATION_CATEGORIES = 'GET_NOTIFICATION_CATEGORIES';
export const GET_NOTIFICATION_CATEGORIES_SUCCEEDED = 'GET_NOTIFICATION_CATEGORIES_SUCCEEDED';
export const UPDATE_PROFILE_NOTIFICATION_SETTINGS = 'UPDATE_PROFILE_NOTIFICATION_SETTINGS';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_SUCCEEDED = 'GET_USER_PROFILE_SUCCEEDED';
export const UPDATE_FAVORITE_GENRES = 'UPDATE_FAVORITE_GENRES';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';

export const GET_CINEMA_LOCATIONS = 'GET_CINEMA_LOCATIONS';
export const GET_CINEMA_LOCATIONS_SUCCEEDED = 'GET_CINEMA_LOCATIONS_SUCCEEDED';
export const STORE_CINEMA_LOCATION = 'STORE_CINEMA_LOCATION';
export const STORE_CINEMA_LOCATION_SUCCEEDED = 'STORE_CINEMA_LOCATION_SUCCEEDED';
export const STORE_SELECTED_FESTIVAL_DATE = 'STORE_SELECTED_FESTIVAL_DATE';
export const STORE_SELECTED_FESTIVAL_DATE_SUCCEEDED = 'STORE_SELECTED_FESTIVAL_DATE_SUCCEEDED';
export const STORE_SELECTED_EVENT_LOCATION = 'STORE_SELECTED_EVENT_LOCATION';
export const STORE_SELECTED_EVENT_LOCATION_SUCCEEDED = 'STORE_SELECTED_EVENT_LOCATION_SUCCEEDED';
export const STORE_SELECTED_MOVIE_FILTERS = 'STORE_SELECTED_MOVIE_FILTERS';
export const STORE_SELECTED_MOVIE_FILTERS_SUCCEEDED = 'STORE_SELECTED_MOVIE_FILTERS_SUCCEEDED';
export const STORE_SELECTED_MOVIES_SORT_BY = 'STORE_SELECTED_MOVIES_SORT_BY';
export const STORE_SELECTED_MOVIES_SORT_BY_SUCCEEDED = 'STORE_SELECTED_MOVIES_SORT_BY_SUCCEEDED';
export const ADD_MOVIE_TO_FAVORITE_FROM_HOME_RECENT_MOVIES = 'ADD_MOVIE_TO_FAVORITE_FROM_HOME_RECENT_MOVIES';
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_HOME_RECENT_MOVIES = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_HOME_RECENT_MOVIES';
export const GET_MOVIES_SCHEDULE = 'GET_MOVIES_SCHEDULE';
export const GET_MOVIES_SCHEDULE_SUCCEEDED = 'GET_MOVIES_SCHEDULE_SUCCEEDED';
export const GET_RECOMMENDED_MOVIES = 'GET_RECOMMENDED_MOVIES';
export const GET_RECOMMENDED_MOVIES_SUCCEEDED = 'GET_RECOMMENDED_MOVIES_SUCCEEDED';
export const ADD_MOVIE_TO_FAVORITE_FROM_RECOMMENDED = 'ADD_MOVIE_TO_FAVORITE_FROM_RECOMMENDED';
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_RECOMMENDED = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_RECOMMENDED'; 
export const ADD_MOVIE_TO_FAVORITE_FROM_BOX_OFFICE = 'ADD_MOVIE_TO_FAVORITE_FROM_BOX_OFFICE'; 
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_BOX_OFFICE = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_BOX_OFFICE'; 
export const ADD_MOVIE_TO_FAVORITE_FROM_SOON_IN_CINEMA = 'ADD_MOVIE_TO_FAVORITE_FROM_SOON_IN_CINEMA';
export const REMOVE_MOVIE_FROM_FAVORITE_FROM_SOON_IN_CINEMA = 'REMOVE_MOVIE_FROM_FAVORITE_FROM_SOON_IN_CINEMA';
export const STORE_SELECTED_HOUR = 'STORE_SELECTED_HOURS';
export const STORE_SELECTED_HOUR_SUCCEEDED = 'STORE_SELECTED_HOURS_SUCCEEDED';
export const STORE_SELECTED_DATE = 'STORE_SELECTED_DATE';
export const STORE_SELECTED_DATE_SUCCEEDED = 'STORE_SELECTED_DATE_SUCCEEDED';

export const GET_SOON_IN_CINEMA_FILTERS = 'GET_SOON_IN_CINEMA_FILTERS';
export const GET_SOON_IN_CINEMA_FILTERS_SUCCEEDED = 'GET_SOON_IN_CINEMA_FILTERS_SUCCEEDED';
export const GET_BOX_OFFICE_GENRE_FILTERS = 'GET_BOX_OFFICE_GENRE_FILTERS';
export const GET_BOX_OFFICE_GENRE_FILTERS_SUCCEEDED = 'GET_BOX_OFFICE_GENRE_FILTERS_SUCCEEDED';

export const GET_SOON_IN_CINEMA_FILTERED_MOVIES = 'GET_SOON_IN_CINEMA_FILTERED_MOVIES';
export const GET_SOON_IN_CINEMA_FILTERED_MOVIES_SUCCEEDED = 'GET_SOON_IN_CINEMA_FILTERED_MOVIES_SUCCEEDED';

export const GET_RECENT_MOVIES_SLIDER = 'GET_RECENT_MOVIES_SLIDER';
export const GET_RECENT_MOVIES_SLIDER_SUCCEEDED = 'GET_RECENT_MOVIES_SLIDER_SUCCEEDED';

export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATE_ORDER_SUCCEEDED = 'CREATE_ORDER_SUCCEEDED';
export const PAY_ORDER = 'PAY_ORDER';
export const PAY_ORDER_SUCCEEDED = 'PAY_ORDER_SUCCEEDED';
export const GET_ORDER_DETAILS = 'GET_ORDER_DETAILS';
export const GET_ORDER_DETAILS_SUCCEEDED = 'GET_ORDER_DETAILS_SUCCEEDED';
export const GET_ORDERS_LIST = 'GET_ORDERS_LIST';
export const GET_ORDERS_LIST_SUCCEEDED = 'GET_ORDERS_LIST_SUCCEEDED';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_ORDER_SUCCEEDED = 'UPDATE_ORDER_SUCCEEDED';
export const REDIRECT_TO_MOBIL_PAY = 'REDIRECT_TO_MOBIL_PAY';

export const GET_TERMS_PAGE = 'GET_TERMS_PAGE';
export const GET_TERMS_PAGE_SUCCEEDED = 'GET_TERMS_PAGE_SUCCEEDED';
export const GET_CONFIDENTIALITY_PAGE = 'GET_CONFIDENTIALITY_PAGE';
export const GET_CONFIDENTIALITY_PAGE_SUCCEEDED = 'GET_CONFIDENTIALITY_PAGE_SUCCEEDED';
export const CONTACT_PAGE = 'CONTACT_PAGE';
export const CONTACT_PAGE_SUCCEEDED = 'CONTACT_PAGE_SUCCEEDED';

export const GET_NEWS_CATEGORIES = 'GET_NEWS_CATEGORIES';
export const GET_NEWS_CATEGORIES_SUCCEEDED = 'GET_NEWS_CATEGORIES_SUCCEEDED';


// WEBPACK FOOTER //
// ./src/SHARED/actions/types.js